<template>
  <section class="recommended home-section bg-gradient pd-both container" id="recommended">
    <h2 class="row-title1">{{ $t("home.recommended.title") }}</h2>
    <channel-list-simple :channels="recommendedChannels" />
  </section>
</template>

<script>
import ChannelListSimple from '../ChannelListSimple.vue';

export default {
  props: ['recommendedChannels'],
  components: {
    'channel-list-simple': ChannelListSimple,
  },
};
</script>
